import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.7795 12.2435L14.9649 11.9226C16.6599 9.00221 15.7532 5.32067 12.876 3.44116C9.99875 1.56164 6.10473 2.10714 3.90499 4.69787C1.70525 7.2886 1.92894 11.0658 4.4203 13.3998C6.91166 15.7337 10.8449 15.8508 13.4817 13.6695L17.5605 17.5909"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Icon;
